import { Address as _Address } from "./Address";
import { CallingCode as _CallingCode } from "./CallingCode";
import { CountryCode as _CountryCode } from "./CountryCode";
import { Currency as _Currency } from "./Currency";
import { Date as _Date } from "./Date";
import { DateRange as _DateRange } from "./DateRange";
import { DateSpan as _DateSpan } from "./DateSpan";
import { DateTime as _DateTime } from "./DateTime";
import { DayOfWeek as _DayOfWeek } from "./DayOfWeek";
import { Digit as _Digit } from "./Digit";
import { Encoding as _Encoding } from "./Encoding";
import { Fixed as _Fixed } from "./Fixed";
import { Language as _Language } from "./Language";
import { Locale as _Locale } from "./Locale";
import { Month as _Month } from "./Month";
import { Time as _Time } from "./Time";
import { TimeRange as _TimeRange } from "./TimeRange";
import { TimeSpan as _TimeSpan } from "./TimeSpan";
import { TimeZone as _TimeZone } from "./TimeZone";
import { Week as _Week } from "./Week";
export var isoly;
(function (isoly) {
    isoly.Address = _Address;
    isoly.CallingCode = _CallingCode;
    isoly.CountryCode = _CountryCode;
    isoly.DateSpan = _DateSpan;
    isoly.DateRange = _DateRange;
    isoly.Digit = _Digit;
    isoly.Currency = _Currency;
    isoly.CurrencyCode = isoly.Currency.Code;
    isoly.Date = _Date;
    isoly.DateTime = _DateTime;
    isoly.DayOfWeek = _DayOfWeek;
    isoly.Encoding = _Encoding;
    isoly.Fixed = _Fixed;
    isoly.Language = _Language;
    isoly.Locale = _Locale;
    isoly.Month = _Month;
    isoly.Time = _Time;
    isoly.TimeRange = _TimeRange;
    isoly.TimeSpan = _TimeSpan;
    isoly.TimeZone = _TimeZone;
    isoly.Week = _Week;
})(isoly || (isoly = {}));
//# sourceMappingURL=index.js.map